import React, { useState, useEffect } from "react";
import { AutoComplete, Input, Button, Grid, Typography, message } from "antd";
import { useMutation, useQuery } from "react-query";
import { secureAxios } from "../../../_helpers/auth";
import { queryClient } from "../../../_helpers/query";
// import { useItemsFine } from "../../../../src/_actions/app/items";
import { useParams } from "react-router-dom";
import { useCreateItem } from "../../../../src/actions/mutations/items";
import { useItemsFine } from "../../../actions/app/items";

const { useBreakpoint } = Grid;

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const useAddUsersToOrg = (onSuccess = () => {}) => {
    const createItem = useCreateItem(
        "junction_directus_users_qdb_organization"
    );
    return useMutation(
        ({ orgId, userId }) =>
            createItem.mutateAsync({
                directus_users_id: userId,
                qdb_organization_id: orgId,
            }),
        {
            onSuccess: () => {
                queryClient.invalidateQueries("org");
                message.success("User successfully added to the organization!");
                onSuccess();
            },
            onError: (error) => {
                if (
                    error?.response?.data?.errors?.[0]?.extensions?.code ===
                    "RECORD_NOT_UNIQUE"
                ) {
                    message.info("User is already in the organization.");
                } else {
                    message.error("Failed to add user to organization.");
                }
            },
        }
    );
};

const AddUserToOrg = ({ existingEmails = [] }) => {
    const { orgId } = useParams(); // expects route like /brand/:orgID/edit, This is not working currently, because orgId can not be fetched from useParams, so for this , we are extracting the orgID from the URL written below in handle submit.
    const [emailInput, setEmailInput] = useState("");
    const isFullEmail = emailRegex.test(emailInput.trim());
    const isAlreadyAdded =
        isFullEmail && existingEmails.includes(emailInput.trim());

    // Fetch org ID by orgName using `name` field
    console.log(orgId);
    const {
        data: orgData,
        isLoading: isOrgLoading,
        isError: isOrgError,
    } = useItemsFine(
        "qdb_organization",
        `filter[name][_eq]=${orgId}&fields[]=id`,
        !!orgId,
        false
    );
    // console.log(orgData)
    // const orgId = orgData?.data?.[0]?.id;

    const {
        data: foundUsers = [],
        isLoading: isFetching,
        refetch,
    } = useItemsFine(
        "directus_users",
        `filter[email][_eq]=${emailInput.trim()}&fields[]=id&fields[]=email&fields[]=first_name&fields[]=last_name`,
        isFullEmail,
        false,
        false
    );

    const addUserMutation = useAddUsersToOrg(() => {
        setEmailInput(""); // Clear input only after success
    });

    useEffect(() => {
        if (isFullEmail) {
            refetch();
        }
    }, [emailInput]);

    const handleSelect = async (value) => {
        const pathArray = window.location.pathname.split("/");
        const orgId = pathArray[3];
        if (!orgId) {
            message.error("Organization not available yet.");
            return;
        }

        const selectedUser = foundUsers.find((u) => u.email === value.trim());
        if (!selectedUser) {
            message.error("Selected user not found.");
            return;
        }

        try {
            await addUserMutation.mutateAsync({
                orgId,
                userId: selectedUser.id,
            });
        } catch {
            // Error is already handled inside mutation
        }
    };

    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    return (
        <div style={{ marginTop: "7px" }}>
            <Typography.Title level={5}>Add Members by Email</Typography.Title>

            <AutoComplete
                style={{ width: isMobile ? "100%" : "50%" }}
                options={foundUsers.map((user) => ({
                    label: `${user.first_name} ${user.last_name} — ${user.email}`,
                    value: user.email,
                }))}
                value={emailInput}
                onChange={setEmailInput}
                onSelect={handleSelect}
                placeholder="Enter full email"
                loading={
                    isFetching || addUserMutation.isLoading || isOrgLoading
                }
            />

            {isAlreadyAdded && (
                <div style={{ marginTop: 8 }}>
                    <Typography.Text type="danger">
                        This user is already part of the organization or
                        invited.
                    </Typography.Text>
                </div>
            )}

            <Button
                type="primary"
                onClick={() => handleSelect(emailInput)}
                disabled={
                    !isFullEmail ||
                    isAlreadyAdded ||
                    !foundUsers.some((u) => u.email === emailInput.trim())
                }
                loading={addUserMutation.isLoading}
                block={isMobile}
                size={isMobile ? "large" : "middle"}
                style={{ marginTop: 8 }}
            >
                Add Member to Organization
            </Button>
        </div>
    );
};

export default AddUserToOrg;
